import api from '../config/api';

const empresaService = {
  async listarEmpresas() {
    try {
      const response = await api.get('/empresas');
      return response.data;
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Error al listar empresas',
        data: [],
      };
    }
  },

  async obtenerEmpresa(empresaId) {
    try {
      const response = await api.get(`/empresas/${empresaId}`);
      return response.data;
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Error al obtener empresa',
      };
    }
  },

  async actualizarRepresentanteLegal(empresaId, datos) {
    try {
      const payload = typeof datos === 'string'
        ? { representante_legal: datos }
        : datos;

      const response = await api.put(`/empresas/${empresaId}/representante-legal`, payload);
      return response.data;
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message || 'Error al guardar representante legal',
        errors: error.response?.data?.errors,
      };
    }
  },
};

export default empresaService;
